<template>
  <article>
    <AreaHelpContactUsBanner />
    <AreaHelpContactUsSupport />
    <AreaHelpContactUsFaqs />
    <AreaHelpContactUsFooter />
  </article>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
  const { provideWebTitle } = useWebsite();

  useSeoMeta({
    title: () => t('seo-title'),
    ogTitle: () => provideWebTitle(t('seo-title')),
    twitterTitle: () => provideWebTitle(t('seo-title')),
    description: () => t('seo-description'),
    ogDescription: () => t('seo-description'),
    twitterDescription: () => t('seo-description'),
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "en-jp": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "en-tw": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "en-kr": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "en-americas": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "en-asia-pacific": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "en-emea": {
    "seo-title": "Contact Us",
    "seo-description": "Reach out to Advantech WISE for personalized IoT support and inquiries about our industry-leading solutions."
  },
  "ja-jp": {
    "seo-title": "お問い合わせ",
    "seo-description": "Advantech WISE のお問い合わせ窓口です。IoT ソリューションやサポートに関するご相談はこちらから。"
  },
  "zh-cn": {
    "seo-title": "联系我们",
    "seo-description": "寻求 Advantech WISE 的支持？联系我们的专业团队，快速解决需求并了解 IoT 解决方案。"
  },
  "zh-tw": {
    "seo-title": "聯繫我們",
    "seo-description": "尋求 Advantech WISE 幫助？聯繫我們的專家團隊，快速解決您的需求，探索 IoT 解決方案。"
  }
}
</i18n>
